const POPUP_BASE_WIDTH = 1024;
const POPUP_BASE_HEIGHT = 768;

// Explicit size and left/top: the desktop agent otherwise opens the window out of sight and the
// browser picks the primary monitor. `noopener` would return null, so the opener is cleared instead.
export const openIdProofingPopup = (): Window | null => {
  const scale = window.devicePixelRatio || 1;
  const screenWidth = window.screen.width || document.documentElement.clientWidth;
  const systemZoom = screenWidth / window.screen.availWidth;
  const width = Math.round((POPUP_BASE_WIDTH * scale) / systemZoom);
  const height = Math.round((POPUP_BASE_HEIGHT * scale) / systemZoom);
  const left = Math.round(window.screenX + (window.outerWidth - width) / 2);
  const top = Math.round(window.screenY + (window.outerHeight - height) / 2);

  const popup = window.open(
    '',
    '_blank',
    `popup,width=${width},height=${height},left=${left},top=${top}`,
  );
  if (popup) {
    popup.opener = null;
  }
  return popup;
};
